




























$ = require 'jquery'

import SpinningCube from '@/components/geotap/SpinningCube'
import StoreLinks from '@/components/geotap/StoreLinks'
import GeotapLogo from '@/components/geotap/GeotapLogo'

export default {
  name: 'marquee'

  data: ->
    ready: false
    geotapCards: require '@/assets/images/games/geotap-game/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.png'
    indiePrize: require '@/assets/images/promo/indie-prize-casual-connect-lucre-games-2018.png'

  components:
    'spinning-cube': SpinningCube
    'store-links': StoreLinks
    'geotap-logo': GeotapLogo

  beforeMount: ->
    setTimeout @buildin, 200

  methods:
    # Scroll down to the next main section
    onDownArrowClick: ->
      $('html, body').animate({ scrollTop: $(".lucre-game-cards").offset().top - 50, easing: 'swing' }, 1000);
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geotap/Marquee.vue